import * as types from './mutation-types';

export default {
  [types.SET_NFE_COLLECTION](state, payload) {
    state.nfeCollection = payload;
  },
  [types.SET_PRE_VALIDATION_NFE](state, payload) {
    state.preValidationNfe = payload;
  },
};
